var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.98468 13.4059C4.11707 13.4059 0.814209 13.9906 0.814209 16.3326C0.814209 18.6745 4.09611 19.2802 7.98468 19.2802C11.8523 19.2802 15.1542 18.6945 15.1542 16.3535C15.1542 14.0126 11.8733 13.4059 7.98468 13.4059Z",
    stroke: "#999EA1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.98464 10.0656C10.5227 10.0656 12.5799 8.00751 12.5799 5.46941C12.5799 2.93132 10.5227 0.874176 7.98464 0.874176C5.44655 0.874176 3.38845 2.93132 3.38845 5.46941C3.37988 7.99894 5.42369 10.057 7.95226 10.0656H7.98464Z",
    stroke: "#999EA1",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.990891de5ec97001c528a295a49e716f.svg";
export { ForwardRef as ReactComponent };